export class CompanySettings {
    constructor(db, companyID) {
        this.db = db;
        this.companyID = companyID;
        this.companyDetails = {
            legalName: '',
            tradingName: '',
            adminEmail: '',
            adminName: '',
            notificationsEnabled: false,
            notificationsType: '',
            defaultNotificationEmail: '',
            businessUnits: {},
            teams: {},
            hasMSP: false,
            msp: null,
            companyData: {},
            complianceModules: {
                accessibleModules: [],
                iso: {},
                iso27701: {},
                e8: {
                    e8Levels: [],
                },
                pa: {},
                ism: {},
            },
        };
    }

    checkComplianceModules = async () => {
        let modules = [];
        try {
            let dbCompliance = await this.db
                .collection('customers')
                .doc(window.companyID)
                .collection('companySettings')
                .doc('complianceModules')
                .get();

            if (dbCompliance.exists) {
                let complianceModuleData = dbCompliance.data();
                console.log(complianceModuleData);

                for (let moduleName in complianceModuleData) {
                    modules.push(moduleName);
                }
            } else {
                console.error("Doc doesn't exist");
            }
        } catch (error) {
            console.error('Error fetching document:', error);
        }

        return modules;
    };


    async loadSettings() {
        try {
            let response = {
                legalName: '',
                tradingName: '',
                adminEmail: '',
                adminName: '',
                notificationsEnabled: false,
                notificationsType: '',
                defaultNotificationEmail: '',
                businessUnits: {},
                teams: {},
                hasMSP: false,
                msp: null,
                companyData: {},
                complianceModules: {
                    accessibleModules: [],
                    iso: {},
                    iso27701: {},
                    e8: {
                        e8Levels: [],
                    },
                    pa: {},
                    ism: {},
                },
            };
            let baseTenancy = this.db.collection('customers').doc(this.companyID);
            return await baseTenancy.get().then(async (baseTenancyDoc) => {
                if (baseTenancyDoc.exists) {
                    let baseTenancyData = baseTenancyDoc.data();
                    response.companyData = baseTenancyData;

                    if (baseTenancyData.hasOwnProperty('mspDetails')) {
                        if (baseTenancyData.mspDetails.hasOwnProperty('msp')) {
                            response.hasMSP = true;
                            response.msp = baseTenancyData.mspDetails.msp;
                        } else if (baseTenancyData.mspDetails.hasOwnProperty('techPartner')) {
                            if (baseTenancyData.mspDetails.techPartner.hasOwnProperty('msp')) {
                                response.hasMSP = true;
                                response.msp = baseTenancyData.mspDetails.techPartner.msp;
                            }
                        }
                    }
                    return await this.checkComplianceModules().then(async (accessibleModules) => {
                        accessibleModules = [...accessibleModules];
                        let companySettings = this.db
                            .collection('customers')
                            .doc(companyID)
                            .collection('companySettings')
                            .doc('general');
                        return await companySettings.get().then(async (companySettingsDoc) => {
                            if (companySettingsDoc.exists) {
                                if (baseTenancyData.customerPlan === undefined) {
                                    let businessUnitsMap = baseTenancyData.customerOrg.teams.businessUnitNames;
                                    let teamsMap = baseTenancyData.customerOrg.teams.teamNames;
                                    response.businessUnits = businessUnitsMap;
                                    response.teams = teamsMap;
                                    await this.checkComplianceModules().then(async (accessibleModules) => {
                                        response.complianceModules.accessibleModules = [...accessibleModules];

                                        for (let moduleName of accessibleModules) {
                                            await this.loadComplianceModuleSettings(moduleName).then((moduleSettings) => {
                                                response.complianceModules[moduleName] = moduleSettings;
                                            });
                                        }

                                        await this.loadISOProductSettings().then((isoSettings) => {
                                            response.complianceModules.iso = isoSettings;
                                        });
                                        await this.loadISO27701ProductSettings().then((isoSettings) => {
                                            response.complianceModules.iso27701 = isoSettings;
                                        });
                                        await this.loadRFFRProductSettings().then((ismSettings) => {
                                            response.complianceModules.ism = ismSettings;
                                        });
                                        await this.loadDISPProductSettings().then((dispSettings) => {
                                            response.complianceModules.DISP = dispSettings
                                        })
                                        // this.loadPAProductSettings().then((paSettings) => {
                                        //     response.complianceModules.pa = paSettings;
                                        //     response.complianceModules.pa['enabled'] =
                                        //         baseTenancyData?.starterEnabled?.privacyActEnabled ?? false;
                                        // });
                                        // this.loadE8ProductSettings().then((e8Settings) => {
                                        //     console.log('E8', e8Settings);
                                        //     response.complianceModules.e8 = e8Settings;
                                        //     response.complianceModules.e8['enabled'] = baseTenancyData?.starterEnabled?.e8Enabled ?? false;

                                        //     if (response.complianceModules.e8.hasOwnProperty('active')) delete response.complianceModules.e8.active;
                                        // });
                                        let notificationsEnabled;
                                        let notificationType;
                                        if (typeof companySettingsDoc.data().companyOverview[7].enabled === 'boolean') {
                                            notificationsEnabled =
                                                companySettingsDoc.data().companyOverview[7].enabled === true ? true : false;
                                            if (notificationsEnabled === true) {
                                                notificationType =
                                                    companySettingsDoc.data().companyOverview[7]?.type !== undefined
                                                        ? companySettingsDoc.data().companyOverview[7]?.type
                                                        : 'email';
                                            } else {
                                                notificationType = 'disabled';
                                            }
                                        }

                                        response.notificationsEnabled = notificationsEnabled;
                                        response.notificationsType = notificationType;

                                        console.log(notificationType);

                                        if (
                                            companySettingsDoc.data().companyOverview[7]?.defaultEmail !== undefined &&
                                            companySettingsDoc.data().companyOverview[7]?.defaultEmail !== '' &&
                                            companySettingsDoc.data().companyOverview[7]?.defaultEmail !== null
                                        ) {
                                            response.defaultNotificationEmail =
                                                companySettingsDoc.data().companyOverview[7]?.defaultEmail;
                                        }
                                    });
                                } else if (baseTenancyData.customerPlan.toLowerCase() === 'starter') {
                                    console.log('Starter');
                                    await this.loadPAProductSettings().then((paSettings) => {
                                        response.complianceModules.pa = paSettings;
                                        response.complianceModules.pa['enabled'] =
                                            baseTenancyData.starterEnabled.privacyActEnabled;
                                    });

                                    await this.loadE8ProductSettings().then((e8Settings) => {
                                        console.log('E8', e8Settings);
                                        response.complianceModules.e8 = e8Settings;
                                        response.complianceModules.e8['enabled'] = baseTenancyData.starterEnabled.e8Enabled;

                                        if (response.complianceModules.e8.hasOwnProperty('active'))
                                            delete response.complianceModules.e8.active;
                                    });

                                    await this.loadDISPProductSettings().then((dispSettings) => {
                                        response.complianceModules.DISP = dispSettings
                                    })
                                }

                                response.legalName = baseTenancyData.customerName;
                                response.tradingName = baseTenancyData.customerFriendlyName;
                                response.adminName =
                                    baseTenancyData.adminName !== undefined
                                        ? baseTenancyData.adminName
                                        : baseTenancyData.customerOwnerName;
                                response.adminEmail =
                                    baseTenancyData.adminEmail !== undefined
                                        ? baseTenancyData.adminEmail
                                        : baseTenancyData.customerOwner;

                                let notificationsEnabled;
                                let notificationType;
                                window.usersArray = baseTenancyData.customerOrg.users;
                                console.log('Base Tenancy Data', baseTenancyData);
                                if (baseTenancyData.hasOwnProperty('emailNotificationsEnabled')) {
                                    notificationsEnabled =
                                        baseTenancyData.emailNotificationsEnabled === true ? true : false;
                                    if (notificationsEnabled) {
                                        notificationType = 'email';
                                    } else {
                                        notificationType = 'disabled';
                                    }
                                } else {
                                    if (typeof companySettingsDoc.data().companyOverview[7].enabled === 'boolean') {
                                        notificationsEnabled =
                                            companySettingsDoc.data().companyOverview[7].enabled === true ? true : false;
                                        if (notificationsEnabled === true) {
                                            notificationType =
                                                companySettingsDoc.data().companyOverview[7]?.type !== undefined
                                                    ? companySettingsDoc.data().companyOverview[7]?.type
                                                    : 'email';
                                        } else {
                                            notificationType = 'disabled';
                                        }
                                    }
                                }

                                response.notificationsEnabled = notificationsEnabled;
                                response.notificationsType = notificationType;

                                // console.log(notificationType);

                                response.defaultNotificationEmail =
                                    companySettingsDoc.data().companyOverview[7]?.defaultEmail !== undefined &&
                                        companySettingsDoc.data().companyOverview[7]?.defaultEmail !== '' &&
                                        companySettingsDoc.data().companyOverview[7]?.defaultEmail !== null
                                        ? companySettingsDoc.data().companyOverview[7]?.defaultEmail
                                        : baseTenancyData.customerOwner;

                                // window.companyDetails = response;

                                return response;
                            } else {
                                if (baseTenancyData.customerPlan.toLowerCase() === 'starter') {
                                    console.log('Starter');
                                    await this.loadPAProductSettings().then((paSettings) => {
                                        response.complianceModules.pa = paSettings;
                                        response.complianceModules.pa['enabled'] =
                                            baseTenancyData.starterEnabled.privacyActEnabled;
                                    });

                                    await this.loadE8ProductSettings().then((e8Settings) => {
                                        console.log('E8', e8Settings);
                                        response.complianceModules.e8 = e8Settings;
                                        response.complianceModules.e8['enabled'] = baseTenancyData.starterEnabled.e8Enabled;

                                        if (response.complianceModules.e8.hasOwnProperty('active'))
                                            delete response.complianceModules.e8.active;
                                    });
                                }

                                response.legalName = baseTenancyData.customerName;
                                response.tradingName = baseTenancyData.customerFriendlyName;
                                response.adminName =
                                    baseTenancyData.adminName !== undefined
                                        ? baseTenancyData.adminName
                                        : baseTenancyData.customerOwnerName;
                                response.adminEmail =
                                    baseTenancyData.adminEmail !== undefined
                                        ? baseTenancyData.adminEmail
                                        : baseTenancyData.customerOwner;

                                // window.companyDetails = response;

                                return response;
                            }
                        });
                    });
                }
            });
        } catch (error) {
            console.error('Error loading company settings:', error);
        }
    }

    async handleCompanySettings(companySettingsDoc, baseTenancyData, accessibleModules) {
        if (baseTenancyData.customerPlan === undefined) {
            // Handle undefined customer plan
            const businessUnitsMap = baseTenancyData.customerOrg.teams.businessUnitNames;
            const teamsMap = baseTenancyData.customerOrg.teams.teamNames;
            this.companyDetails.businessUnits = businessUnitsMap;
            this.companyDetails.teams = teamsMap;

            this.companyDetails.complianceModules.accessibleModules = [...accessibleModules];

            // Load settings for each module
            for (let moduleName of accessibleModules) {
                const moduleSettings = await this.loadComplianceModuleSettings(moduleName);
                this.companyDetails.complianceModules[moduleName] = moduleSettings;
            }

            // Load specific product settings
            this.companyDetails.complianceModules.iso = await this.loadISOProductSettings();
            this.companyDetails.complianceModules.iso27701 = await this.loadISO27701ProductSettings();
            this.companyDetails.complianceModules.ism = await this.loadRFFRProductSettings();
            this.companyDetails.complianceModules.DISP = await this.loadDISPProductSettings();

            // Handle notifications
            if (typeof companySettingsDoc.data().companyOverview[7].enabled === 'boolean') {
                const notificationsEnabled = companySettingsDoc.data().companyOverview[7].enabled === true;
                const notificationType = notificationsEnabled
                    ? (companySettingsDoc.data().companyOverview[7]?.type !== undefined
                        ? companySettingsDoc.data().companyOverview[7]?.type
                        : 'email')
                    : 'disabled';

                this.companyDetails.notificationsEnabled = notificationsEnabled;
                this.companyDetails.notificationsType = notificationType;

                if (companySettingsDoc.data().companyOverview[7]?.defaultEmail !== undefined &&
                    companySettingsDoc.data().companyOverview[7]?.defaultEmail !== '' &&
                    companySettingsDoc.data().companyOverview[7]?.defaultEmail !== null) {
                    this.companyDetails.defaultNotificationEmail = companySettingsDoc.data().companyOverview[7]?.defaultEmail;
                }
            }

        } else if (baseTenancyData.customerPlan.toLowerCase() === 'starter') {
            // Handle starter plan
            const paSettings = await this.loadPAProductSettings();
            this.companyDetails.complianceModules.pa = paSettings;
            this.companyDetails.complianceModules.pa['enabled'] = baseTenancyData.starterEnabled.privacyActEnabled;

            const e8Settings = await this.loadE8ProductSettings();
            this.companyDetails.complianceModules.e8 = e8Settings;
            this.companyDetails.complianceModules.e8['enabled'] = baseTenancyData.starterEnabled.e8Enabled;
            if (this.companyDetails.complianceModules.e8.hasOwnProperty('active')) {
                delete this.companyDetails.complianceModules.e8.active;
            }

            const dispSettings = await this.loadDISPProductSettings();
            this.companyDetails.complianceModules.DISP = dispSettings;
        }

        // Set common details
        this.setCommonDetails(baseTenancyData, companySettingsDoc);
    }

    async handleNoCompanySettings(baseTenancyData) {
        if (baseTenancyData.customerPlan?.toLowerCase() === 'starter') {
            // Handle starter plan without company settings
            const paSettings = await this.loadPAProductSettings();
            this.companyDetails.complianceModules.pa = paSettings;
            this.companyDetails.complianceModules.pa['enabled'] = baseTenancyData.starterEnabled.privacyActEnabled;

            const e8Settings = await this.loadE8ProductSettings();
            this.companyDetails.complianceModules.e8 = e8Settings;
            this.companyDetails.complianceModules.e8['enabled'] = baseTenancyData.starterEnabled.e8Enabled;
            if (this.companyDetails.complianceModules.e8.hasOwnProperty('active')) {
                delete this.companyDetails.complianceModules.e8.active;
            }
        }

        // Set basic details
        this.companyDetails.legalName = baseTenancyData.customerName;
        this.companyDetails.tradingName = baseTenancyData.customerFriendlyName;
        this.companyDetails.adminName = baseTenancyData.adminName !== undefined
            ? baseTenancyData.adminName
            : baseTenancyData.customerOwnerName;
        this.companyDetails.adminEmail = baseTenancyData.adminEmail !== undefined
            ? baseTenancyData.adminEmail
            : baseTenancyData.customerOwner;
    }

    setCommonDetails(baseTenancyData, companySettingsDoc) {
        this.companyDetails.legalName = baseTenancyData.customerName;
        this.companyDetails.tradingName = baseTenancyData.customerFriendlyName;
        this.companyDetails.adminName = baseTenancyData.adminName !== undefined
            ? baseTenancyData.adminName
            : baseTenancyData.customerOwnerName;
        this.companyDetails.adminEmail = baseTenancyData.adminEmail !== undefined
            ? baseTenancyData.adminEmail
            : baseTenancyData.customerOwner;

        // Handle notifications
        let notificationsEnabled;
        let notificationType;

        if (baseTenancyData.hasOwnProperty('emailNotificationsEnabled')) {
            notificationsEnabled = baseTenancyData.emailNotificationsEnabled === true;
            notificationType = notificationsEnabled ? 'email' : 'disabled';
        } else if (companySettingsDoc && typeof companySettingsDoc.data().companyOverview[7].enabled === 'boolean') {
            notificationsEnabled = companySettingsDoc.data().companyOverview[7].enabled === true;
            notificationType = notificationsEnabled
                ? (companySettingsDoc.data().companyOverview[7]?.type !== undefined
                    ? companySettingsDoc.data().companyOverview[7]?.type
                    : 'email')
                : 'disabled';
        }

        this.companyDetails.notificationsEnabled = notificationsEnabled;
        this.companyDetails.notificationsType = notificationType;

        // Set default notification email
        if (companySettingsDoc &&
            companySettingsDoc.data().companyOverview[7]?.defaultEmail !== undefined &&
            companySettingsDoc.data().companyOverview[7]?.defaultEmail !== '' &&
            companySettingsDoc.data().companyOverview[7]?.defaultEmail !== null) {
            this.companyDetails.defaultNotificationEmail = companySettingsDoc.data().companyOverview[7]?.defaultEmail;
        } else {
            this.companyDetails.defaultNotificationEmail = baseTenancyData.customerOwner;
        }
    }

    // Helper methods for loading different product settings
    async loadComplianceModuleSettings(moduleName) {
        const complianceModulesDoc = await this.db
            .collection('customers')
            .doc(this.companyID)
            .collection('companySettings')
            .doc('complianceModules')
            .get();

        if (!complianceModulesDoc.exists) return {};

        const moduleSettings = complianceModulesDoc.data()[moduleName];
        const response = {};

        if (!moduleSettings || Object.keys(moduleSettings).length === 0) {
            response['Enabled'] = false;
            return response;
        }

        // Special handling for E8 module
        if (moduleName === 'ACSCE8MM102021') {
            const e8Levels = complianceModulesDoc.data()['standardsAdded']
                .filter(item => item.startsWith('e8_level'));
            response['e8Levels'] = e8Levels;
        }

        for (let key in moduleSettings) {
            const setting = moduleSettings[key];
            if (typeof setting === 'object' && setting !== null) {
                if (setting.hasOwnProperty('value')) {
                    let settingName = setting['settingName'];
                    let settingValue = setting['value'];

                    // Handle Firebase Timestamp
                    if (settingValue && settingValue.hasOwnProperty('seconds')) {
                        let date = settingValue.toDate();
                        let offset = date.getTimezoneOffset();
                        date = new Date(date.getTime() - offset * 60 * 1000);
                        settingValue = date.toISOString().split('T')[0];
                    }

                    response[settingName.replaceAll(' ', '')] = settingValue;
                } else {
                    response[key] = setting;
                }
            } else {
                response[key] = setting;
            }
        }

        return response;
    }

    async loadISOProductSettings() {
        const complianceModulesDoc = await this.db
            .collection('customers')
            .doc(this.companyID)
            .collection('companySettings')
            .doc('complianceModules')
            .get();

        if (!complianceModulesDoc.exists) return {};

        const iso27001CompanySettings = complianceModulesDoc.data()['iso27001-2013'];
        const response = {};

        for (let key in iso27001CompanySettings) {
            const setting = iso27001CompanySettings[key];
            if (!setting.hasOwnProperty('value')) continue;

            let settingName = setting['settingName'];
            let settingValue = setting['value'];

            response[settingName.replaceAll(' ', '')] = settingValue;

            // Handle Firebase Timestamp
            if (settingValue.hasOwnProperty('seconds')) {
                let date = settingValue.toDate();
                let offset = date.getTimezoneOffset();
                date = new Date(date.getTime() - offset * 60 * 1000);
                settingValue = date.toISOString().split('T')[0];
            }

            response[settingName.replaceAll(' ', '')] = settingValue;
        }

        return response;
    }

    async loadISO27701ProductSettings() {
        const complianceModulesDoc = await this.db
            .collection('customers')
            .doc(this.companyID)
            .collection('companySettings')
            .doc('complianceModules')
            .get();

        if (!complianceModulesDoc.exists) return {};

        const iso27701CompanySettings = complianceModulesDoc.data()['iso27701'];
        const response = {};

        for (let key in iso27701CompanySettings) {
            const setting = iso27701CompanySettings[key];
            if (!setting.hasOwnProperty('value')) continue;

            let settingName = setting['settingName'];
            let settingValue = setting['value'];

            response[settingName.replaceAll(' ', '')] = settingValue;

            // Handle Firebase Timestamp
            if (settingValue.hasOwnProperty('seconds')) {
                let date = settingValue.toDate();
                let offset = date.getTimezoneOffset();
                date = new Date(date.getTime() - offset * 60 * 1000);
                settingValue = date.toISOString().split('T')[0];
            }

            response[settingName.replaceAll(' ', '')] = settingValue;
        }

        return response;
    }

    async loadRFFRProductSettings() {
        const complianceModulesDoc = await this.db
            .collection('customers')
            .doc(this.companyID)
            .collection('companySettings')
            .doc('complianceModules')
            .get();

        if (!complianceModulesDoc.exists) return {};

        const ismCompanySettings = complianceModulesDoc.data()?.ism || {};
        const response = {};

        if (Object.keys(ismCompanySettings).length <= 0) {
            response['Enabled'] = false;
            return response;
        }

        for (let key in ismCompanySettings) {
            let setting = ismCompanySettings[key];
            if (setting.hasOwnProperty('seconds')) {
                let date = setting.toDate();
                let offset = date.getTimezoneOffset();
                date = new Date(date.getTime() - offset * 60 * 1000);
                setting = date.toISOString().split('T')[0];
            }
            response[key.replaceAll(' ', '')] = setting;
        }

        console.log('ISM Product Settings', response);
        return response;
    }

    async loadDISPProductSettings() {
        const complianceModulesDoc = await this.db
            .collection('customers')
            .doc(this.companyID)
            .collection('companySettings')
            .doc('complianceModules')
            .get();

        if (!complianceModulesDoc.exists) return {};

        const dispCompanySettings = complianceModulesDoc.data()?.DISP || {};
        const response = {};

        if (Object.keys(dispCompanySettings).length <= 0) {
            response['Enabled'] = false;
            return response;
        }

        for (let key in dispCompanySettings) {
            let setting = dispCompanySettings[key];
            if (setting.hasOwnProperty('seconds')) {
                let date = setting.toDate();
                let offset = date.getTimezoneOffset();
                date = new Date(date.getTime() - offset * 60 * 1000);
                setting = date.toISOString().split('T')[0];
            }
            response[key.replaceAll(' ', '')] = setting;
        }

        console.log('DISP Product Settings', response);
        return response;
    }

    async loadPAProductSettings() {
        const complianceModulesDoc = await this.db
            .collection('customers')
            .doc(this.companyID)
            .collection('companySettings')
            .doc('complianceModules')
            .get();

        if (!complianceModulesDoc.exists) return {};

        const privacyActSettings = complianceModulesDoc.data()['privacyAct'];
        const response = {};

        for (let key in privacyActSettings) {
            const setting = privacyActSettings[key];
            if (!setting.hasOwnProperty('value')) {
                response[key] = setting;
                continue;
            }

            let settingName = setting['settingName'];
            let settingValue = setting['value'];

            response[settingName.replaceAll(' ', '')] = settingValue;

            // Handle Firebase Timestamp
            if (settingValue.hasOwnProperty('seconds')) {
                let date = settingValue.toDate();
                let offset = date.getTimezoneOffset();
                date = new Date(date.getTime() - offset * 60 * 1000);
                settingValue = date.toISOString().split('T')[0];
            }

            response[settingName.replaceAll(' ', '')] = settingValue;
        }

        return response;
    }

    async loadE8ProductSettings() {
        const complianceModulesDoc = await this.db
            .collection('customers')
            .doc(this.companyID)
            .collection('companySettings')
            .doc('complianceModules')
            .get();

        if (!complianceModulesDoc.exists) return {};

        const e8Settings = complianceModulesDoc.data()['ACSCE8MM102021'];
        console.log(complianceModulesDoc.data()['standardsAdded']);

        const e8Levels = complianceModulesDoc.data()['standardsAdded']
            .filter(item => item.startsWith('e8_level'));

        const response = {
            e8Levels: e8Levels
        };

        for (let key in e8Settings) {
            const setting = e8Settings[key];
            if (!setting.hasOwnProperty('value')) {
                response[key] = setting;
                continue;
            }

            let settingName = setting['settingName'];
            let settingValue = setting['value'];

            response[settingName.replaceAll(' ', '')] = settingValue;

            // Handle Firebase Timestamp
            if (settingValue.hasOwnProperty('seconds')) {
                let date = settingValue.toDate();
                let offset = date.getTimezoneOffset();
                date = new Date(date.getTime() - offset * 60 * 1000);
                settingValue = date.toISOString().split('T')[0];
            }

            response[settingName.replaceAll(' ', '')] = settingValue;
        }

        return response;
    }
} 